import './Main.css';
import { Link } from 'react-router-dom';
export const HeaderLinks = () => {
  return (
    <menu>
      <li><Link to="/">Home</Link></li>
      <li><Link to="/involvement">Outreach</Link></li>
      <li><Link to="/about">About</Link></li>
      <li><Link to="/contact">Contact</Link></li>
      <li><Link to="/beliefs">Beliefs</Link></li>
    </menu>
  )
}

export const FooterLinks = () => {
    return (
        <div id="allFooter">
            <p className="footerText">Pastor Vince Pallozzi</p>
            <p className="footerText">706-338-0430</p>
            <p className="footerText">2712 Sandy Cross Rd, Royston, GA 30662</p>
            <div>
              <a href="https://www.facebook.com/penningtonchapel" 
                className="fa fa-facebook"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Pennington Chapel Facebook">
              </a>
              <a href="/contact"
                className="fa fa-envelope-o"
                rel="noopener noreferrer"
                aria-label="Send us an email!">
              </a>
            </div>
        </div>
    )
}